<template>
    <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="inDate"
    transition="scale-transition" bottom left
    offset-y
    min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field  :style="`max-width:${width}`" :solo="solo" :class="inputClass"
            v-model="fmDate" :dense="dense" :outlined="outlined"
             @blur="date = moment(fmDate, 'YYYY-MM-DD')"
            :label="label"
            :prepend-icon="icon"
            readonly v-bind="attrs" v-on="on" hide-details
            ></v-text-field>
        </template>
        <v-date-picker v-model="inDate" locale="vi" type="month" :readonly="readonly">
        
            <v-spacer></v-spacer>
            <v-btn outlined color="red" @click="apply(null)">Clear</v-btn>
            <v-btn text color="secondary" @click="menu = false" >
                Cancel
            </v-btn>
            <v-btn text color="orange"
            @click="apply" >
            OK
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script>
import * as moment from "moment/moment";
export default {
    name: "DatePickerRange",
    props:["value", "icon", "dense", "outlined", "label", "readonly", "solo", "width", "inputClass"],
    data() {
        return {
            menu:false,
            inDate: [],
            fmDate: null
        }
    },
    watch: {
        inDate (val) {
            if(val){
                this.fmDate = moment(this.inDate).format("MM/YYYY")
            }
            else{
                this.fmDate = null
            }
        },
    },
    methods:{
        apply(event, value){
            console.log(value)
            if(value != undefined) {
                if(value) {
                    this.inDate = value
                }else {
                    this.inDate = null
                }
            }
            this.$refs.menu.save(this.inDate);
            this.$emit("input", this.inDate);
        }
    },
    created(){
        this.inDate = this.value
        // this.fmDate = moment(this.value).format("DD/MM/YYYY")
    }
}
</script>